export default __webpack_public_path__ + "static/media/isi_logo.a849eb0f.png";